module.exports = "<ngx-loading-bar color=\"#fff\"></ngx-loading-bar>\n<router-outlet></router-outlet>\n\n<div *ngIf=\"!prod\" class=\"corner-ribbon bottom-right sticky orange shadow\">{{env.name}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main